
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/challenges/upcoming/[[...challengeId]]",
      function () {
        return require("private-next-pages/challenges/upcoming/[[...challengeId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/challenges/upcoming/[[...challengeId]]"])
      });
    }
  